module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/library/modules/_library.js
// module id = 46
// module chunks = 0